module.exports = __webpack_public_path__ + "static/media/bg.23e33912.png";